import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import { useExpertInsightsAuth } from "./useExpertInsightsAuth";
import { ExpertInsightsContextProvider } from "./ExpertInsightsContext";
import { NavBar } from "../../../components/domain/navigation/NavBar";
import { ExpertInsightsNav } from "./ExpertInsightsNav";

function ExpertInsightsShell() {
  useExpertInsightsAuth();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <NavBar />
      <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <ExpertInsightsNav />
        <Box component="main" sx={{ flex: 1, overflowY: "auto" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

/** Shell for all authenticated /expert-insights/* routes. Auth guard lives in useExpertInsightsAuth. */
export default function ExpertInsightsLayout() {
  return (
    <ExpertInsightsContextProvider>
      <ExpertInsightsShell />
    </ExpertInsightsContextProvider>
  );
}
